import { useState, useEffect } from "react";
const useMatspecSectionHeader = props => {
  const [matspecTableHeader, setMatspecTableHeader] = useState(null);
  const [language, setLanguage] = useState(null);

  useEffect(() => {
    const { config, translations, fieldTranslations, currentTabKey, singleAd } = props;
    let configType =
      currentTabKey === "print" || singleAd ? "matspecHeaderPrint" : "matspecHeader";
    let string = config[configType];
    let matches = string.match(/\{.*?\}/);
    let headerArray = [];
    while (matches) {
      //console.log(matches[0]);
      const match = matches[0].replace("{", "").replace("}", "");
      let translation =
        match.indexOf("MaterialSpecification.") !== -1
          ? fieldTranslations && fieldTranslations["Job.matspec:" + match]
          : match.indexOf("Insertion.") !== -1
          ? fieldTranslations && fieldTranslations["Job.insertion:" + match]
          : null;
          if (match === "MaterialSpecification.select") {
            translation = "";
          }
      headerArray.push(translation);
      string = string.replace(matches[0], "");
      matches = string.match(/\{.*?\}/);
    }
    headerArray = headerArray.filter(item => item !== null);
    setMatspecTableHeader(headerArray);
    setLanguage(translations);
    return () => console.log("unmounting MatspecSectionHeader");
  }, [props.translations, props.fieldTranslations, props.currentTabKey]);

  return { matspecTableHeader, language };
};

export default useMatspecSectionHeader;



// WEBPACK FOOTER //
// ./src/components/MatspecSectionHeader/useMatspecSectionHeader.js